import { Link } from "react-router-dom";
import { agcArticleLink } from "../data/Data";

const ext = { target: "_blank", rel: "noopener noreferrer", className: "text-link" };

export default function AdditionalReading() {
  return (
    <div className="page page--narrow">
      <p className="breadcrumb">
        <Link to="/adaptive-growth-culture">Adaptive Growth Culture</Link> › Additional Reading
      </p>
      <h1 className="page-title">Additional Reading</h1>

      <section className="reading-block">
        <h2 className="section-title">Adaptive Growth Culture</h2>
        <p>
          Trish Hambridge’s full article:{" "}
          <a href={agcArticleLink} {...ext}>
            <em>Adaptive Growth Culture: A New Blueprint for Life After Aphasia</em>
          </a>
        </p>
      </section>

      <section className="reading-block">
        <h2 className="section-title">Neuroplasticity</h2>
        <p>
          The brain possesses the remarkable capacity to reorganize pathways, create new
          connections, and, in some cases, even create new neurons - a concept called
          neuroplasticity or brain plasticity.
        </p>
        <ul className="plain-list">
          <li>
            <a href="https://www.verywellmind.com/what-is-brain-plasticity-2794886" {...ext}>
              What Is Neuroplasticity?
            </a>{" "}
            article
          </li>
          <li>
            Sentis animation on{" "}
            <a href="https://www.youtube.com/watch?v=ELpfYCZa87g" {...ext}>Neuroplasticity</a>
          </li>
          <li>
            <a href="/newsletters/Neuroplasticity.pdf" {...ext}>Neuroplasticity PDF</a>
          </li>
        </ul>
      </section>

      <section className="reading-block">
        <h2 className="section-title">The Growth Mindset</h2>
        <p>
          There are emotional impacts from the trauma of stroke and aphasia. After the trauma,
          there is a feeling of loss, from physical changes, changes in language abilities, and
          changes in community and social roles. The loss leads to grieving and can become chronic
          grieving. The emotional impacts can affect communication abilities.
        </p>
        <p>
          Adopting a growth mindset can help process the trauma and positively affect recovery.
          Engage in the process of improving.
        </p>

        <h3 className="sub-title">Read</h3>
        <ul className="plain-list">
          <li>
            <a href="https://medium.com/@coyboggs/keeping-a-growth-mindset-in-trauma-8ccd47fd9930" {...ext}>
              Keeping a Growth Mindset in Trauma
            </a>
          </li>
          <li>
            <a href="https://www.lifteducation.com/growth-mindset-for-adult-learners/" {...ext}>
              Growth Mindset for Adult Learners
            </a>
          </li>
          <li>
            <a href="https://strokeonward.org/guide/" {...ext}>
              Emotional Journey in Stroke Recovery
            </a>
          </li>
        </ul>

        <h3 className="sub-title">Watch</h3>
        <p>
          <a href="https://youtu.be/J-swZaKN2Ic?si=00FPH5O7WUKsNxPN" {...ext}>
            The power of yet | Carol S Dweck | TEDxNorrköping
          </a>
        </p>
        <div className="video-wrap">
          <iframe
            src="https://www.youtube.com/embed/J-swZaKN2Ic?si=nenscyzFa4hrw1i5"
            title="The power of yet | Carol S Dweck | TEDxNorrköping"
            frameBorder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
            allowFullScreen
          ></iframe>
        </div>
      </section>
    </div>
  );
}
